import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import sha256 from "sha256"
import {
  updateOrderData,
  validatePaymentForm,
  changePaymentGateway,
} from '../actions'
import orderSelector from '../selectors/orderSelector'
import RulesAgreement from '../components/RulesAgreement'
import RodoAgreement from '../components/RodoAgreement'
import PersonalDataAgreement from '../components/PersonalDataAgreement'
import PartnersAgreement from '../components/PartnersAgreement'

const isInIframe = () => {
  try {
    return window.self != window.top
  } catch(e) {
    return true
  }
}

class DotpayPaymentForm extends React.Component {
  render() {
    const { order, payment_operation } = this.props
    const paymentDescription = `${I18n.t("fe.order.order_name", {order_id: order.data.id})} - ${order.data.product_name}`.substring(0, 250)
    return (
      <form
        method="POST"
        target={isInIframe() ? "_blank" : undefined}
        action={st.GLOBALS.DOTPAY_ENDPOINT_URL}>
        <input type="hidden" name="api_version" value="dev" />
        <input type="hidden" name="id" value={order.data.dotpay_account_id} />
        <input type="hidden" name="amount" value={payment_operation.transaction_amount.value} />
        <input type="hidden" name="description" value={paymentDescription} />
        <input type="hidden" name="url" value={st.urlWithCurrentQuery(`${st.GLOBALS.BACKEND_URL}platnosci/${payment_operation.id}/zakoncz?order_id=${order.data.id}&order_token=${order.data.token}${isInIframe() ? '&_iframe=1' : ''}`)} />
        <input type="hidden" name="type" value="3" />
        <input type="hidden" name="buttontext" value={I18n.t("fe.NewOrderPaymentForm.dotpay_go_back_button")} />
        <input type="hidden" name="urlc" value={`${st.GLOBALS.BACKEND_URL}platnosci/${payment_operation.id}/dotpay_notify`} />
        <input type="hidden" name="control" value={payment_operation.id} />
        <input type="hidden" name="email" value={order.data.customer_email} />
        <input type="hidden" name="phone" value={order.data.customer_phone_number} />
        <input type="hidden" name="p_info" value={st.GLOBALS.DOTPAY_P_INFO} />
        <input type="hidden" name="p_email" value={st.GLOBALS.DOTPAY_P_EMAIL} />
        <button
          type="submit"
          className="btn btn-lg btn-primary">
          {(
            I18n.t("fe.NewOrderPaymentForm.submit.pay_with_dotpay", {
              price: st.formatMoney(payment_operation.transaction_amount)
            })
          )}
        </button>
      </form>
    )
  }
}

class PaypalPaymentForm extends React.Component {
  _renderPaypalButton(element) {
    const { order, payment_operation } = this.props
    const paymentDescription = `${I18n.t("fe.order.order_name", {order_id: order.data.id})} - ${order.data.product_name}`.substring(0, 126)
    if (!element || this._paypalButtonRendered) { return }
    paypal.Button.render({
      env: st.GLOBALS.PAYPAL_MODE === "live" ? "production" : "sandbox",
      client: {
        [st.GLOBALS.PAYPAL_MODE === "live" ? "production" : "sandbox"]: order.data.paypal_client_api_key,
      },
      locale: ({
        pl: "pl_PL",
        ru: "ru_RU",
        en: "en_GB"
      })[I18n.locale],
      style: {
        color: "blue",
        shape: "rect",
        size: "medium",
        label: "pay",
      },
      commit: true,
      payment: (data, actions) => {
        return actions.payment.create({
          intent: "sale",
          transactions: [
            {
              reference_id: `Tripsomnia Order #${order.data.id}`,
              custom: `Tripsomnia Order #${order.data.id}, Payment Operation #${payment_operation.id}`,
              amount: {
                total: payment_operation.transaction_amount.value,
                currency: payment_operation.transaction_amount.currency
              },
              description: paymentDescription,
              notify_url: `${st.GLOBALS.BACKEND_URL}platnosci/${payment_operation.id}/paypal_notify`,
              order_url: st.urlWithCurrentQuery(`${st.GLOBALS.BACKEND_URL}zamowienia/${order.data.id}?t=${order.data.token}${isInIframe() ? '&_iframe=1' : ''}`),
            }
          ],
          redirect_urls: {
            return_url: st.urlWithCurrentQuery(`${st.GLOBALS.BACKEND_URL}platnosci/${payment_operation.id}/zakoncz?order_id=${order.data.id}&order_token=${order.data.token}&payment_status=OK${isInIframe() ? '&_iframe=1' : ''}`),
            cancel_url: st.urlWithCurrentQuery(`${st.GLOBALS.BACKEND_URL}zamowienia/${order.data.id}?t=${order.data.token}${isInIframe() ? '&_iframe=1' : ''}`),
          }
        })
      },
      onAuthorize: (data, actions) => {
        return actions.payment.execute()
          .then(
            payment => {
              window.location.href = st.urlWithCurrentQuery(`${st.GLOBALS.BACKEND_URL}platnosci/${payment_operation.id}/zakoncz?order_id=${order.data.id}&order_token=${order.data.token}&payment_status=OK${isInIframe() ? '&_iframe=1' : ''}`)
            },
            error => {
              console.error && console.error("PayPal actions.payment.execute() failed: " + JSON.stringify(error))
            }
          )
      },
      onCancel: data => {

      }
    }, element)
    this._paypalButtonRendered = true
  }

  render() {
    const { order, payment_operation, loading } = this.props
    return (
      <div ref={ref => this._renderPaypalButton(ref)}></div>
    )
  }
}

class PayUPaymentForm extends React.Component {
  componentDidMount(){
    const { order, payment_operation } = this.props
    console.log(payment_operation)
    const paymentDescription = `${I18n.t("fe.order.order_name", {order_id: order.data.id})} - ${order.data.product_name}`.substring(0, 126)
    let currency = ""
    let amount = ""
    if(["USD", "EUR"].includes(payment_operation.amount.currency)){
      currency = payment_operation.amount.currency
      amount = payment_operation.amount.value
    } else {
      currency = payment_operation.transaction_amount.currency
      amount = payment_operation.transaction_amount.value
    }

    const pos_id = order.data.payu_configuration[currency.toLowerCase()].pos_id
    const md5 = order.data.payu_configuration[currency.toLowerCase()].md5
    console.log("POSID:"+pos_id)
    const script = document.createElement("script");
    const inputs = [
      { name: "merchant-pos-id", value: pos_id },
      { name: "shop-name", value: 'TEST' },
      { name: "total-amount", value: parseInt(payment_operation.transaction_amount.value * 100) },
      { name: "currency-code", value: payment_operation.transaction_amount.currency },
      { name: "customer-language", value: 'en' },
      { name: "store-card", value: 'false' },
      { name: "payu-brand", value: 'false' },
      { name: "widget-mode", value: 'pay' },
      { name: "customer-email", value: order.data.customer_email },
    ]
    inputs.forEach(function(el, i, ar){
      script.setAttribute(el.name, el.value);
    });
    script.setAttribute("src", "https://secure.payu.com/front/widget/js/payu-bootstrap.js")
    script.setAttribute("success-callback", "payuCallback")
    script.setAttribute("payment-operation-id", payment_operation.id)
    script.setAttribute("id", "payu_inline_widget")
    script.setAttribute("continue-url", st.urlWithCurrentQuery(`${st.GLOBALS.BACKEND_URL}platnosci/${payment_operation.id}/zakoncz?order_id=${order.data.id}&order_token=${order.data.token}`))

    const values = inputs.sort(this.compare_inputs).map(input => input.value)
    const values_string = values.join("")+md5
    const signature = sha256(values_string)

    script.setAttribute("sig", signature)

    document.body.appendChild(script);
  }

  compare_inputs(a,b){
    if (a.name < b.name)
      return -1;
    if (a.name > b.name)
      return 1;
    return 0;
  }

  render(){
    const calculatedWidth = window.innerWidth <= 600 ? '100%' : 474;

    return(
      <div>
        <div id="payu-widget" style={{width: calculatedWidth, margin: 'auto', borderRadius: 28, backgroundColor: 'white', padding: 10}}></div>
      </div>
    )
  }
}

@connect(
  state => ({
    order: orderSelector(state),
    payment_operation: state.paymentFormData.payment_operation,
    isFormLoading: state.paymentFormData.isLoading,
    gateway: state.paymentFormData.gateway,
    errors: state.errors,
  }),
  dispatch => bindActionCreators({
    updateOrderData,
    validateForm: validatePaymentForm,
    changePaymentGateway,
  }, dispatch)
)
export default class NewOrderPaymentForm extends React.Component {
  componentDidMount() {
    console.log(this.props.order.data)
    if (!this.props.order.requiresCustomerRulesAgreement && !this.props.gateway) {
      if (this.props.order.data.should_render_payu_form) {
        this.props.changePaymentGateway("payu")
      } else if (this.props.order.data.should_render_dotpay_form) {
        this.props.changePaymentGateway("dotpay")
      } else if (this.props.order.data.should_render_paypal_form) {
        this.props.changePaymentGateway("paypal")
      }
    }
  }

  handleOrderPropChange(attribute, event) {
    const value = event.target.type === "checkbox" ? event.target.checked : event.target.value;
    this.props.updateOrderData({
      [attribute]: value
    });
  }

  renderBaseErrors() {
    const baseErrors = _(this.props.errors)
      .values()
      .flatten()
      .value();

    return baseErrors.length > 0 && (
      <div className="alert alert-danger">
        {baseErrors.map((error, i) => <p key={i}>{error}</p>)}
      </div>
    )
  }

  renderFormMessage() {
    if (this.props.order.data.confirmation_installment_before_company_approval) {
      return (
        <div>
          <p><strong>{I18n.t("fe.NewOrderPaymentForm.almost_booked")}</strong></p>
          <p>{I18n.t(`fe.NewOrderPaymentForm.pay_to_book.${this.props.order.data.app_config.kind}`, {
            confirmation_installment_transaction_amount: st.formatMoney(this.props.order.data.confirmation_installment_transaction_amount)
          })}</p>
        </div>
      );
    } else if (this.props.order.data.confirmation_installment_after_company_approval) {
      return (
        <div>
          <p>{I18n.t("fe.NewOrderPaymentForm.please_pay_online_deposit", {
            confirmation_installment_transaction_amount: st.formatMoney(this.props.order.data.confirmation_installment_transaction_amount)
          })}</p>
          <p>{I18n.t("fe.NewOrderPaymentForm.payment_deadline", {
            pauses_at: this.props.order.data.pauses_at ? st.formatTime(this.props.order.data.pauses_at) : ""
          })}</p>
          <p>{I18n.t("fe.NewOrderPaymentForm.cancelled_if_not_paid")}</p>
        </div>
      );
    } else if (this.props.order.data.confirmation_installment_without_company_approval) {
      return (
        <div>
          <p><strong>{I18n.t("fe.NewOrderPaymentForm.almost_finished")}</strong></p>
          <p>{I18n.t("fe.NewOrderPaymentForm.pay_to_finish", {
            confirmation_installment_transaction_amount: st.formatMoney(this.props.order.data.confirmation_installment_transaction_amount)
          })}</p>
        </div>
      );
    }
  }

  renderSubmitButton() {
    if (!this.props.isFormLoading && this.props.gateway && this.props.payment_operation && this.props.gateway === this.props.payment_operation.source_type) {
      if (this.props.gateway === "dotpay") {
        return (
          <DotpayPaymentForm
            order={this.props.order}
            payment_operation={this.props.payment_operation}
            />
        )
      } else if (this.props.gateway === "paypal") {
        return (
          <PaypalPaymentForm
            order={this.props.order}
            payment_operation={this.props.payment_operation}
            />
        )
      } else if (this.props.gateway === "payu") {
        return (
          <PayUPaymentForm
            order={this.props.order}
            payment_operation={this.props.payment_operation}
            />
        )
      }
    } else {
      return (
        <button
          className="btn btn-lg btn-primary"
          disabled>
          {!this.props.isFormLoading && (
            this.props.order.data.confirmation_installment_after_company_approval
              ? I18n.t("fe.NewOrderPaymentForm.submit.pay", {
                price: st.formatMoney(this.props.order.data.confirmation_installment_transaction_amount)
              })
              : I18n.t("fe.NewOrderPaymentForm.submit.book_and_pay", {
                price: st.formatMoney(this.props.order.data.confirmation_installment_transaction_amount)
              })
          )}
          {!!this.props.isFormLoading && <i className="fa fa-spin fa-circle-o-notch"></i>}
        </button>
      )
    }
  }

  render() {
    return (
      <div className="form form-horizontal NewOrderPaymentForm">
        {this.renderFormMessage()}

        {this.props.order.requiresCustomerRulesAgreement &&
          <RulesAgreement
            order={this.props.order}
            checked={!!this.props.order.data.rules_agreement}
            onChange={this.handleOrderPropChange.bind(this, "rules_agreement")} />}
        {this.props.order.requiresCustomerRulesAgreement &&
          <PersonalDataAgreement
            checked={!!this.props.order.data.personal_data_agreement}
            onChange={this.handleOrderPropChange.bind(this, "personal_data_agreement")} />}
        {this.props.order.requiresCustomerRulesAgreement &&
          <RodoAgreement
            checked={!!this.props.order.data.rodo_agreement}
            onChange={this.handleOrderPropChange.bind(this, "rodo_agreement")} />}
        {this.props.order.requiresCustomerRulesAgreement &&
          <PartnersAgreement
            checked={!!this.props.order.data.partners_agreement}
            onChange={this.handleOrderPropChange.bind(this, "partners_agreement")} />}

        {!!this.props.order.data.should_render_dotpay_form && (
          <div className="form-group">
            <div className="u-textAlignCenter">
              <div className="NewOrderPaymentForm-choose_label">
                {I18n.t("fe.NewOrderPaymentForm.choose_payment_method")}
              </div>

              <label className="radio-inline u-marginHorizontal NewOrderPaymentForm-option" style={{display: 'inline-flex', alignItems: 'center'}}>
                <input type="radio"
                  checked={this.props.gateway === "dotpay"}
                  onChange={() => this.props.changePaymentGateway("dotpay")}
                  />
                <div className="NewOrderPaymentForm-option-image">
                  <img src="/assets/dotpay-logo.png" alt="Dotpay" height="24" />
                </div>
                <span className="NewOrderPaymentForm-option-label">{I18n.t("fe.NewOrderPaymentForm.by_bank_wire_or_credit_card")}</span><br />
              </label>

              {!!this.props.order.data.should_render_paypal_form && (
                <label className="radio-inline u-marginHorizontal NewOrderPaymentForm-option costam" style={{display: 'inline-flex', alignItems: 'center'}}>
                  <input type="radio"
                    checked={this.props.gateway === "paypal"}
                    onChange={() => this.props.changePaymentGateway("paypal")}
                    />
                  <div className="NewOrderPaymentForm-option-image">
                    <img src="/assets/paypal-logo.svg" alt="PayPal" height="24" />
                  </div>
                  <span className="NewOrderPaymentForm-option-label">{I18n.t("fe.NewOrderPaymentForm.by_paypal")}</span>
                </label>
              )}
            </div>
          </div>
        )}

        {!!this.props.order.data.should_render_payu_form && (
          <div className="form-group">
            <div className="u-textAlignCenter">

              <label className="radio-inline u-marginHorizontal NewOrderPaymentForm-option" style={{display: 'inline-flex', alignItems: 'center'}}>
                <input type="radio"
                  checked={this.props.gateway === "payu"}
                  onChange={() => this.props.changePaymentGateway("payu")}
                  />
                <div className="NewOrderPaymentForm-option-image">
                  <img src="/assets/payu-logo.png" alt="PayU" height="55" />
                </div>
                <span className="NewOrderPaymentForm-option-label">{I18n.t("fe.NewOrderPaymentForm.by_payu")}</span>
              </label>
            </div>
          </div>
        )}

        {!!this.props.order.data.should_render_paypal_form && !this.props.order.data.should_render_dotpay_form && (
          <div className="form-group">
            <div className="u-textAlignCenter">

              <label className="radio-inline u-marginHorizontal NewOrderPaymentForm-option" style={{display: 'inline-flex', alignItems: 'center'}}>
                <input type="radio"
                  checked={this.props.gateway === "paypal"}
                  onChange={() => this.props.changePaymentGateway("paypal")}
                  />
                <div className="NewOrderPaymentForm-option-image">
                  <img src="/assets/paypal-logo.svg" alt="PayPal" height="24" />
                </div>
                <span className="NewOrderPaymentForm-option-label">{I18n.t("fe.NewOrderPaymentForm.by_credit_card")}</span>
              </label>
            </div>
          </div>
        )}

        <div className="form-group">
          <div className="form-actions-center">
            {this.renderSubmitButton()}
          </div>
        </div>

        {this.props.order.data.has_pricing && !this.props.order.data.confirmation_installment_after_company_approval && (
          <div className="new-order-form-rules-footer">
            ({I18n.t("fe.NewOrderPaymentForm.order_with_payment_requirement")})
          </div>
        )}

        {this.renderBaseErrors()}

        <hr />

        <div className="new-order-form-security-footer">
          <p>{I18n.t("fe.NewOrderPaymentForm.safe_payments_guaranteed_by")}</p>
          <img src="/assets/cloudflare-logo.png" alt="CloudFlare" height="35" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/containers/NewOrderPaymentForm.jsx